import { useApiGet } from 'mf_core/query';
import { useMutation } from '@tanstack/react-query';

export function useGetWidgetDetails() {
  const apiGet = useApiGet();

  return useMutation({
    mutationFn: (body: {
      filters?: string;
      insightKey?: number;
      widgetKey: number;
    }) => {
      let widgetsUrl = `/shared/v1/insights/widgets?widgetKey=${body?.widgetKey}`;

      if (body?.insightKey) {
        widgetsUrl = `/shared/v1/insights/widgets?widgetKey=${body.widgetKey}&insightkey=${body.insightKey}`;
      }

      if (body?.filters) {
        widgetsUrl += `&filters=${body?.filters}`;
      }

      const data = apiGet(widgetsUrl);

      return data;
    },
  });
}
